<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.93371 18.467C14.6465 18.467 18.467 14.6465 18.467 9.93371C18.467 5.22089 14.6465 1.40039 9.93371 1.40039C5.22089 1.40039 1.40039 5.22089 1.40039 9.93371C1.40039 14.6465 5.22089 18.467 9.93371 18.467Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.6009 20.6L15.9609 15.96"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
